import axios from 'axios';

declare let core_object: any;

export default class verifyToken{

    protected elBox: string;
    protected elFormSpin: string = 'bgdrop-spin';
    protected url_api_verify_token: string;

    /**
     * Constructor
     * @param elBox 
     */
    constructor(
        elBox: string,
    ){
        
        this.elBox = elBox;
        this.url_api_verify_token = core_object.rest_urls.comments_verify_token;

    }

    checkToken(){
        
        const _that = this;
    
        const box = document.querySelector(this.elBox) as HTMLElement | null;

        if(box != null){
            
            const searchParams = new URLSearchParams(window.location.search);

            const get_token = searchParams.get('token-activate') as string;

            const post_data = {
                'token': get_token,
            };
    
            const queryString = new URLSearchParams(post_data).toString();

            const spin = this.btnSpin();

            box?.append(spin);
            
            // Call ajax
            axios.post(this.url_api_verify_token, queryString)
                .then(function (response: any) {

                spin.remove();

                let responseStatus: boolean = response.data.status;

                let message = response.data.message;
                    
                box.prepend(message);

            })
            .catch(function (error:any){

                spin.remove();

                let message = core_object.error_messages.general;
                    
                box.prepend(message);
                

            });
        
        }
    
    
    }

    /**
     * Create spin
     * @returns 
     */
    btnSpin(){
        
        const spin = document.createElement('i');

        spin.setAttribute('id', this.elFormSpin);
        spin.setAttribute('class', 'fa-solid fa-circle-notch fa-spin ml-1 mt-1');

        return spin;

    }

}